<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main" style="padding: 60px;">
          <div class="title">
            关于我们
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">

              <li class="clickable"><a href="/about?id=xmjj"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>设施简介</a></li>

              <li class="clickable "><a href="/about8"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>研究院简介</a></li>

              <li class="clickable "><a href="/about2"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>领导团队</a></li>

              <li class="clickable "><a href="about6?id=zhyxjd"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科研设施</a></li>
              <li class="clickable active"><a href="/about3"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>技术系统</a></li>

              <li class="clickable"><a href="/about5?id=yxgltx"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>组织架构</a></li>
            </ul>
          </div>
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  export default {
    data () {
      return {
        richText: '',
      };
    },
    created () {
        this.richText = '<p style="text-align: left; "><span style="margin-left: 295px;font-size: 22px; border-bottom: solid 3px #0c5cc8;">技术系统</span></p>'
          + '<br/>'
          + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">国家设施技术系统分别位于瑞金医院和闵行校区的两个基地，是“优势突出、密切联系、互补相容、功能完整”的有机整体，主要包括资源信息系统、技术支撑系统和临床转化系统三大板块，并与三大类疾病的科研转化形成“三纵三横”的总体格局。</span></p>'
          + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;"><b>资源信息系统</b>包括标准化临床生物样本库和队列样本库、临床资源深度开发平台和转化医学研究综合信息系统等设施，为转化医学研究提供基础性临床信息支撑。</span></p>'
          + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;"><b>技术支撑系统</b>包括生物标志物和新药研发平台、诊疗药物和仪器开发平台、分子病理与影像技术研究平台、转化医学临床转化技术联合研究实验室、医理工协同创新实验室等设施，重点支持疾病早期诊断、治疗和预防方法、技术、药物和医疗器械的研究，实现产、医、研的深度融合发展。</span></p>'
          + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;"><b>临床转化系统</b>包括临床转化基地等设施，旨在促进和加速前沿技术和基础医学研究成果向临床应用转化。</span></p>'
          + '<p style="margin-left: 295px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">设施的成功建设将使转化医学研究构成从基础到临床上下游结合的完整技术链，在关键技术和平台方面达到国际先进水平，成为我国围绕三大类疾病转化医学研究的重要技术支撑平台和人才培养基地，为国家生物医药体系创新和人民健康事业做出显著贡献。</span></p>'

          + '<p style="margin-left: 295px; margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsxtfb1.png" alt="" width="800" ></p>'

          + '<p>&nbsp;</p>'

},
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }

  .b-richtext {
    text-align:left;
    margin-top: -50px;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 20px;
    }
    line-height: 32px;
  }

  ///////////////
  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }
  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 35px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }

  .contentRight {
    padding: 1.3rem 2rem;
    margin-left: 250px;
  }

  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {border-bottom: solid 1px #c6dbf5;border-right: solid 1px #c6dbf5;}
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 30px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}
</style>



// WEBPACK FOOTER //
// src/pages/about3/index.vue